import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import LoadingScreen from './components/LoadingScreen';
import HelpPrompt from './components/HelpPrompt';
import InterfaceUI from './components/InterfaceUI';
import ProjectsModal from './components/ProjectsModal';
import ResumeModal from './components/ResumeModal';
import eventBus from './EventBus';
import './style.css';

const App = () => {
    const [loading, setLoading] = useState(true);
    const [showProjects, setShowProjects] = useState(false);
    const [showResume, setShowResume] = useState(false);

    useEffect(() => {
        eventBus.on('loadingScreenDone', () => {
            setLoading(false);
        });

        eventBus.on('toggleProjects', (show: boolean) => {
            setShowProjects(show);
        });

        eventBus.on('toggleResume', (show: boolean) => {
            setShowResume(show);
        });
    }, []);

    return (
        <div id="ui-app">
            {!loading && <HelpPrompt />}
            <LoadingScreen />
            <ProjectsModal visible={showProjects} onClose={() => setShowProjects(false)} />
            <ResumeModal visible={showResume} onClose={() => setShowResume(false)} />
        </div>
    );
};

const createUI = () => {
    ReactDOM.render(<App />, document.getElementById('ui'));
};

const createVolumeUI = () => {
    ReactDOM.render(<InterfaceUI />, document.getElementById('ui-interactive'));
};

export { createUI, createVolumeUI };
